import React from "react";

function ResumeItem({ year, title, desc }) {
  return (
    <li>
      <div className="list_inner">
        <div className="time">
          <span>{year}</span>
        </div>
        <div className="place">
          <h3>{title}</h3>
          <span>{desc}</span>
        </div>
      </div>
    </li>
  );
}

export default ResumeItem;
